import React, {Component} from 'react';
import './App.css';
import {reduxForm, formValueSelector} from 'redux-form';
import NumberofBox from './NumberofBox'
import DeliveryAddresses from './DeliveryAddresses'
import Billing from './Billing'
import database from './loginconfig'

class App extends React.Component {
    constructor(props) {
        super(props)
        this.nextPage = this.nextPage.bind(this)
        this.previousPage = this.previousPage.bind(this)
        this.state = {
            page: 1,
            checkemail: '',
            oos: true
        }
    }

    componentDidMount() {
        database.ref('/OOS').once('value')
            .then(snapshot => {
                console.log(snapshot.val())
                this.setState({oos: snapshot.val()})
            })
    }

    previousPage() {
        this.setState({page: this.state.page - 1});
        window.scrollTo(0, 0);
    }

    nextPage() {
        this.setState({page: this.state.page + 1});
        window.scrollTo(0, 0);
    }

    render() {
        const {page} = this.state;
        const {onSubmit} = this.props;
        console.log(page)
        return (
            <div className="ala-carte_App">
                <hr/>
                {page === 1 &&
                <NumberofBox onSubmit={this.nextPage}/>
                }
                {page === 2 &&
                <DeliveryAddresses oos={this.state.oos} onClickPrev={this.previousPage} onSubmit={this.nextPage}/>
                }
                {page === 3 &&
                <Billing oos={this.state.oos} onClickPrev={this.previousPage} onSubmit={onSubmit}/>
                }
            </div>
        );
    }
}








export default reduxForm({
    form: 'fieldArrays', // <------ same form name
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(App)


// WEBPACK FOOTER //
// ./src/App.js